import { isClient } from '@cred/shared/utils'
import { CLIENT_SDK_GLOBAL_NAME, WIDGET_ERROR_PREFIX } from '../const'

const NO_SDK_GLOBAL_ERROR_NAME = `${WIDGET_ERROR_PREFIX} Can't find SDKClient global store`

export const setToSDKClientGlobal = (dataObj) => {
  if (isClient()) {
    window[CLIENT_SDK_GLOBAL_NAME] = Object.assign(window[CLIENT_SDK_GLOBAL_NAME] || {}, dataObj)
  }
}

export const getSDKClientGlobal = () => {
  if (isClient()) {
    const SDKClientGlobal = window[CLIENT_SDK_GLOBAL_NAME]
    if (SDKClientGlobal) {
      return SDKClientGlobal
    } else {
      console.warn(NO_SDK_GLOBAL_ERROR_NAME)
    }
  }
}

export let fallbackConfig = {}

export const setFallbackConfig = ({ appName }) => {
  fallbackConfig.appName = appName
}
